export default __webpack_public_path__ + "static/media/dev-azure-static-github.a19594e6.png";